import type { SearchEntry } from './types';

// ダイアログ内の設定は、編集対象を選べる一覧まで案内する。
type Detail = [
  id: string,
  name: string,
  keywords: string,
  focus: string,
  path?: string,
  permission?: 'owner' | 'operate',
];
const details: Detail[] = [
  ['appearance-mode', '表示モード', 'theme 自動 ダーク ライト', 'appearance-mode'],
  ['appearance-background', '背景のテーマ', 'background 外観 表示', 'appearance-background'],
  ['appearance-accent', 'アクセント色', 'accent color 外観 表示', 'appearance-accent'],
  ['appearance-style', 'スタイル', 'style 外観 表示', 'appearance-style'],
  ['appearance-density', '表示の密度', 'density 余白 外観', 'appearance-density'],
  ['appearance-fontSize', '文字の大きさ', 'font size フォント 外観 表示', 'appearance-fontSize'],
  ['appearance-motion', '画面の動き', 'motion アニメーション 外観 表示', 'appearance-motion'],
  ['homepage-name', 'ホームページに表示する名前', 'homepage サイト タイトル', 'homepage-name', '/settings', 'owner'],
  [
    'homepage-description',
    'ホームページの短い説明',
    'homepage サイト 案内 紹介',
    'homepage-description',
    '/settings',
    'owner',
  ],
  [
    'homepage-discord',
    'ホームページの Discord 招待リンク',
    'homepage discord invite URL',
    'homepage-discord',
    '/settings',
    'owner',
  ],
  ['account-password', 'パスワードを変更', 'password アカウント ログイン', 'account'],
  ['account-totp', '認証アプリを変更', '2FA TOTP 2段階認証 二段階認証 ワンタイムコード QR', 'account'],
  ['account-recovery', 'リカバリーコードを再発行', 'recovery code 復旧 紛失 認証', 'account'],
  ['invite', '利用者を招待', 'invite user ユーザー 追加 招待リンク', 'users', '/users', 'owner'],
  [
    'user-role',
    '利用者の権限を変更',
    'role user ユーザー owner admin viewer オーナー 管理者 閲覧',
    'users',
    '/users',
    'owner',
  ],
  ['user-reset', '利用者の認証情報を再設定', 'reset ユーザー パスワード 認証アプリ 紛失', 'users', '/users', 'owner'],
  [
    'template-software',
    'テンプレートのソフト・バージョン',
    'template Minecraft Paper Fabric Forge NeoForge ビルド',
    'templates',
    '/templates?tab=server',
  ],
  [
    'template-resources',
    'テンプレートのリソース',
    'template RAM メモリ ヒープ Xmx Xms CPU ディスク',
    'templates',
    '/templates?tab=server',
  ],
  ['template-placement', 'テンプレートの配置', 'template ノード 重さ 優先 node', 'templates', '/templates?tab=server'],
  [
    'template-game',
    'テンプレートのゲーム設定',
    'template 最大人数 難易度 PvP MOTD ホワイトリスト properties',
    'templates',
    '/templates?tab=server',
  ],
  [
    'template-jvm',
    'テンプレートの Java 起動引数',
    'template JVM Aikar flags GC 追加引数',
    'templates',
    '/templates?tab=server',
  ],
  [
    'template-mods',
    'テンプレートの Mod・プラグイン',
    'template mod plugin modpack 追加 削除 依存',
    'templates',
    '/templates?tab=server',
  ],
  [
    'template-proxy',
    'テンプレートの Velocity 経由の接続',
    'template proxied proxy 接続先 入口',
    'templates',
    '/templates?tab=server',
  ],
  [
    'template-properties',
    'テンプレートの追加プロパティ',
    'template server.properties 詳細 設定ファイル',
    'templates',
    '/templates?tab=server',
  ],
  [
    'client-template-assign',
    'クライアント Mod テンプレートを割り当て',
    'client mod template サーバー 適用 一括 ランチャー 公開',
    'client-templates',
    '/templates?tab=client',
  ],
  [
    'client-template-duplicate',
    'クライアント Mod テンプレートを別の版で複製',
    'client mod template Minecraft コピー バージョン',
    'client-templates',
    '/templates?tab=client',
  ],
  [
    'client-template-side',
    'クライアント Mod の必要性',
    'client mod template 必須 任意 削除 追加 検索',
    'client-templates',
    '/templates?tab=client',
  ],
];

export const panelDetails: SearchEntry[] = details.map(([id, name, keywords, focus, path, permission]) => ({
  id,
  name,
  keywords,
  focus,
  path: path ?? '/settings',
  permission,
  description: path?.startsWith('/templates') ? 'テンプレートを選んで編集します' : 'Panel の設定',
}));
